import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import OptimizelyProvider from './context/OptimizelyProvider';
import { getEnv } from '../environment';
import { Banner } from './components/Banners/Banner';
import NMFHeader from './components/Header/NMFHeader';
import { useNmfTimer } from './hooks/useNmfTimer';
import { useBootstrapLD } from './hooks/useBootstrapLD';
import GlobalNavInternalContext from './context/GlobalNavInternalContext';
import { UniversalNavigationContext } from './context/UniversalNavigationContext';

const NewMemberNavTemplate = ({ env, step, isEditCampaignOpen }) => {
  const externalContextData = useContext(UniversalNavigationContext);
  const { userId } = useNmfTimer();
  const {
    downloadMobileAppWebBannerFF,
    downloadMobileAppWebBannerReady,
    ordersCtaFF,
    ordersCtaReady,
    webRatingsAndReviewInGlobalNavDropDownFF,
    webRatingsAndReviewInGlobalNavDropDownReady,
    ccToastNotificationFF,
    ccToastNotificationReady,
    newMemberOnboardingFF,
    newMemberOnboardingReady,
  } = useBootstrapLD(env, userId);
  const contextValue = {
    env: getEnv(env),
    ...externalContextData,
    flags: {
      downloadMobileAppWebBannerFF,
      downloadMobileAppWebBannerReady,
      ordersCtaFF,
      ordersCtaReady,
      webRatingsAndReviewInGlobalNavDropDownFF,
      webRatingsAndReviewInGlobalNavDropDownReady,
      ccToastNotificationFF,
      ccToastNotificationReady,
      newMemberOnboardingFF,
      newMemberOnboardingReady,
    },
  };

  return (
    <React.StrictMode>
      <OptimizelyProvider>
        {/* TODO: add use memo hook for pass this value*/}
        {/*eslint-disable-next-line react/jsx-no-constructed-context-values*/}
        <GlobalNavInternalContext.Provider value={contextValue}>
          <Banner />
          <NMFHeader step={step} isEditCampaignOpen={isEditCampaignOpen} />
        </GlobalNavInternalContext.Provider>
      </OptimizelyProvider>
    </React.StrictMode>
  );
};

NewMemberNavTemplate.propTypes = {
  env: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired,
};

export default React.memo(NewMemberNavTemplate);
